export default {
  menu: {
    dashboard: 'Dashboard',
    invoices: 'Invoices',
    transactions: 'Transactions',
    payments: 'Payments',
    history: 'Transaction History',
    achBankAccount: 'ACH Bank Accounts',
    summary: 'Account Reports',
    account: 'Your Account',
    accountDataUpdates: 'Account Data Updates',
    plaidBankAccounts: 'Plaid Bank Accounts',
    connectedBankAccounts: 'Connected bank accounts',
    createInvoice: 'Add New Invoice',
    resources: 'Resources',
    holiday: 'Bank Holiday List',
    instructions: 'Drip Bank Details',
    chargesCalc: 'Charges Calculator',
    logout: 'Logout'
  },
  dashboard: {
    title: 'Dashboard',
    offlineBanner: {
      title:
        'Our company will have a holiday on 2nd September, Monday for US Labor Day!',
      text: 'Our team is functioning but we will not be able to process any funding. Funding will resume on Tuesday, 3rd September.'
    },
    freshdeskWidget: 'Message us',
    freshdeskWidgetDisabled:
      'This feature is available only for users with signatory access in your organization.',
    quickGlance: {
      pending: {
        type: 'Pending',
        text: 'Invoices'
      },
      outstanding: {
        type: 'Outstanding',
        text: 'Invoices'
      },
      collections: {
        type: 'Due',
        text: 'Invoices'
      },
      settled: {
        type: 'Settled',
        text: 'Invoices'
      },
      helpTexts: {
        pending: 'Pending',
        advance: 'Advance',
        advanced: 'Advanced',
        invoices: 'Invoices',
        settlement: 'Settlement',
        payments: 'Payments',
        overdue: 'Overdue'
      },
      cardList: [
        {
          label: 'Advance Pending',
          count: ['processing', 'approved', 'deposited'],
          class: 'pending',
          filter: ['processing', 'approved', 'deposited']
        },
        {
          label: 'Advanced Invoices',
          count: ['advanced'],
          class: 'overdue',
          filter: ['advanced']
        },
        {
          label: 'Repaid Invoices',
          count: ['paid', 'settled'],
          class: 'advanced',
          filter: ['paid', 'settled']
        }
      ]
    },
    pendingInvoicesWidget: {
      title: 'Advances In Progress',
      viewAll: 'View All Pending Invoices →',
      table: {
        reference: 'Reference',
        importer: 'Importer',
        value: 'Invoice Value'
      },
      view: 'View →',
      edit: 'Edit →',
      noPending: "You don't have any pending invoices.",
      willCome: 'When there is a pending invoice , it’ll appear here.',
      invoiceTableFields: [
        {
          key: 'reference',
          label: 'Invoice Reference'
        },
        {
          key: 'exporter',
          label: 'Seller'
        },
        {
          key: 'statusStage',
          label: 'Status'
        },
        {
          key: 'value',
          label: 'Advance Value'
        }
      ]
    },
    pendingPaymentsWidget: {
      title: 'Advanced Invoices',
      subtitle: 'Current and Past Due Amount',
      viewAll: 'View All Advanced Invoices →',
      table: {
        reference: 'Reference',
        importer: 'Importer',
        value: 'Invoice Value'
      },
      view: 'View →',
      edit: 'Edit →',
      noPending: "You don't have any payments due to Drip.",
      willCome: 'When there is an upcoming payment, it’ll appear here.',
      paymentTableFields: [
        {
          key: 'reference',
          label: 'Invoice Number'
        },
        {
          key: 'repayment',
          label: 'Due Date'
        },
        {
          key: 'collection_amount',
          label: 'Amount Due + Drip Fees'
        },
        {
          key: 'action',
          label: 'Actions'
        }
      ]
    },
    accountDetailsAccordion: {
      title: 'Overdraft limit - frequently asked questions'
    },
    accountNumbers: {
      title: 'Drip Credit Overview',
      totalLimitLabel: 'Available Credit',
      progressLabel: 'Used Credit',
      ddpProgressLabel: 'Dynamic Drawing Power',
      outstandingLabel: 'Credit Limit',
      increaseLimit: 'Increase my limit →',
      pendingLimit: 'Credit Limit Pending',
      requestModal: {
        loading: 'Loading...',
        ok: 'OK',
        successMessage:
          'Thank you for submitting this request. You will receive an email shortly acknowledging your request and a link where you can follow the status of your ticket.'
      },
      effective: 'effective',
      link: 'Please click here to review your pricing details',
      modalTitle: 'Pricing details',
      availableDripBaseLimit: 'Available Drip base limit',
      availableLimit: 'Available Drip limit',
      availableBaseLimit: 'Available base limit',
      availableOverDraftLimit: 'Available overdraft limit',
      overDraftInterestRate: 'Overdraft premium transaction fee rate',
      interestRate: 'Interest rate',
      transactionFee: 'Transaction fee',
      note: 'Please note: We will only utilize your overdraft limit in case your base limit is exhausted. '
    },
    pricingDetails: {
      title:
        'There has been an update to your pricing terms. These terms are applicable as of ',
      desc: 'Your revised pricing is',
      effective: 'effective',
      link: 'Please click here to review your pricing details',
      modalTitle: 'Pricing details',
      availableLimit: 'Available limit',
      interestRate: 'Interest rate',
      transactionFee: 'Transaction fee'
    },
    domesticOverdraftBanner: {
      title: 'Pre-shipment Invoices',
      subtitlePrepend: 'We can now finance your',
      subtitleAppend: 'Domestic & International',
      contact: 'To know more',
      requestCallbackWidget: {
        requestCallBack: 'Request a callback',
        successMessage1: 'Request received!',
        successMessage2: 'Your account manager will reach out to you shortly.',
        errorMessage: 'Something went wrong!'
      }
    },
    b2bServiceBanner: {
      new: 'NEW!',
      title: 'Finance your Service Invoices',
      info: "Drip's Credit Line now helps you cover almost any B2B service invoices— freight, logistics, marketing, insurance, and more.",
      contact: 'Want to know more?',
      requestCallbackWidget: {
        requestCallBack: 'Request a callback',
        successMessage1: 'Request received!',
        successMessage2: 'Your account manager will reach out to you shortly.',
        errorMessage: 'Something went wrong!'
      }
    },
    overDraftLimitBanner: {
      title:
        'Congratulations! You are pre-approved for a new overdraft facility',
      subTitlePrepend: 'You can now access an additional limit of',
      subTitleAppend:
        'You can learn more about your overdraft pricing by going to account details page.',
      accountDetails: 'Account details',
      close: 'Close'
    },
    dripCreditLimitWidget: {
      title: 'Drip Credit Overview',
      totalDripLimit: 'Total Drip limit',
      totalDripBaseLimit: 'Total Drip base limit',
      usedCreditLimit: 'Used',
      totalCreditLimit: 'Total',
      availableCreditLimit: 'Available',
      dripCreditLimit: 'Drip credit limit',
      dripBaseLimit: 'Drip base limit',
      availableBaseLimit: 'Available base limit',
      availableOverdraftLimit: 'Available overdraft limit',
      usedBaseLimit: 'Used base limit',
      usedOverdraftLimit: 'Used overdraft limit',
      knowMoreTitle: 'Know more about your credit and profile',
      knowMoreTitleText: 'Know more about your credit',
      knowMoreButton: 'Learn more'
    },
    transactionsWidget: {
      title: 'Latest Transactions',
      viewAll: 'View All Transactions  →',
      table: {
        reference: 'Reference',
        importer: 'Importer',
        value: 'Invoice Value',
        status: 'Status',
        actions: 'Actions'
      },
      noRecentTransactions: "You don't have any latest transactions.",
      willCome: 'When there is a transaction, it’ll appear here.',
      invoiceTableFields: [
        {
          key: 'reference',
          label: 'Invoice Number'
        },
        {
          key: 'date',
          label: 'Transaction Date'
        },
        {
          key: 'importer',
          label: 'Seller'
        },
        {
          key: 'type',
          label: 'Type'
        },
        {
          key: 'value',
          label: 'Transaction Amount'
        }
      ]
    },
    tour: {
      info: 'Welcome to <span class="text-primary">Drip Capital\'s SCF</span>  Portal.<div class="mt-2">Click here to avail more insights about our financing solution</div>',
      addInvoice:
        'Submit your invoice and take the first step towards fulfilling your working capital needs',
      quickGlance: 'Get a bird’s eye view of your submitted invoices',
      accountLimit:
        'Track your available credit limit, working capital utilization and outstanding charges, all at one go!',
      advancesAndPayments:
        'Obtain all the necessary details of those invoices that need to be advanced and also those that are yet to be settled',
      transactions:
        'Now it is that easy to acquire information about your advances, deposits and payment transactions at an invoice level',
      alerts:
        'Your one stop destination to get alerts of your pending action items, processing updates, and more'
    }
  },
  dripTour: {
    startJourney: 'START YOUR JOURNEY',
    next: 'NEXT',
    back: 'BACK',
    gotIt: 'GOT IT'
  },
  transactions: {
    index: {
      htmlTitle: 'Transactions | Drip Portal',
      title: 'Transactions',
      fields: {
        deposits: [
          {
            key: 'disbursed',
            label: 'Date'
          },
          {
            key: 'invoice_reference',
            label: 'Invoice Number'
          },
          {
            key: 'invoice_exporter',
            label: 'Seller'
          },
          {
            key: 'value',
            label: 'Value'
          }
        ],
        advances: [
          {
            key: 'disbursed',
            label: 'Date'
          },
          {
            key: 'invoice_reference',
            label: 'Invoice Number'
          },
          {
            key: 'invoice_exporter',
            label: 'Seller'
          },
          {
            key: 'value',
            label: 'Value'
          }
        ],
        payments: [
          {
            key: 'dated',
            label: 'Payment Date'
          },
          {
            key: 'invoice_reference',
            label: 'Invoice Number'
          },
          {
            key: 'invoice_exporter',
            label: 'Seller'
          },
          {
            key: 'value',
            label: 'Value'
          }
        ]
      },
      transactionFilters: [
        {
          text: 'Deposits',
          value: 'deposits'
        },
        {
          text: 'Advances',
          value: 'advances'
        },
        {
          text: 'Payments',
          value: 'payments'
        }
      ]
    }
  },
  holidays: {
    index: {
      title: 'Resources',
      list: 'Bank Holiday List',
      desc: 'USA BANK HOLIDAY LIST',
      caption:
        'Note : OUR PARTNER BANKS WILL BE CLOSED ON THESE DAYS. ALL ADVANCES, SETTLEMENTS, AND BANK COVER LETTER APPLICATIONS WILL BE PROCESSED ON THE NEXT WORKING DAY.'
    }
  },
  instructions: {
    index: {
      title: 'Resources',
      list: 'Payment Instructions',
      desc: 'Drip Capital INC. Bank Details'
    }
  },
  chargesCalc: {
    index: {
      title: 'Resources',
      list: 'Charges Calculator',
      desc: 'SELECT AN INVOICE'
    },
    table: {
      value: 'Invoice Face Value (A)',
      advanceTotal: 'Advance Total (B)',
      depositTotal: 'Deposits Total',
      disbursedDate: 'Disbursed Date',
      dueDate: 'Due Date',
      receivedDate: 'Received Date',
      receivedAmount: 'Received Amount (Expected)(C)',
      overdraftLimitUtilized: 'Overdraft limit utilized'
    },
    calcDetailsTable: {
      duration: 'Duration',
      overdue: 'Overdue Days',
      factoringRate: 'Interest rate',
      overDraftPremiumTransactionFee: 'Overdraft premium transaction fee rate',
      transactionFee: 'Transaction fee (D1)',
      overDraftTransactionfee: 'Overdraft premium transaction fee (D2)',
      advanceDuration: 'Duration',
      advanceRegularInterest: 'Regular Interest',
      stepUpDbrDuration: 'Step-up DBR days #{number}',
      stepUpDbrRate: 'Step-up DBR Rate applied #{number}',
      regularInterest: 'Regular Interest Amount (E)',
      overdueInterest: 'Overdue Interest Amount (F)',
      stepUpDbrInterest: 'Step-up interest on advance (F1)',
      totalInterest: 'Total Interest (G=E+F+F1)',
      totalInterestWithoutDBR: 'Total Interest (G=E+F)',
      lateFee: 'Late Fee (H)',
      docFee: 'Doc Fee (I)',
      processingFee: 'Processing Fee (J1)',
      adjustments: 'Adjustments (J2)',
      otherFees: 'Other Fees (K=H+I+J1+J2)',
      totalFees: 'Total Fees (L=D1+D2+G+K)',
      totalFeesOD: 'Total Fees (L=D1+G+K)',
      collectionAmount: 'Collection Amount',
      settlementBalance: 'Settlement Balance',
      settlementAdjusts: 'Settlement Adjusts',
      totalSettlement: 'Total Settlement',
      toolTips: {
        dueDate:
          'These are the charges on your invoice based on Drip receiving the payment on selected date',
        expectedDate: 'This is the calculated charges as per the due date'
      }
    },
    tableHeadings: {
      invoiceDetails: 'INVOICE DETAILS',
      calculationDetails: 'CALCULATIONS DETAILS'
    },
    select: {
      noInvoiceFound: "We couldn't find any invoices with",
      placeHolder: 'SELECT AN INVOICE'
    },
    noInvoicesHelpertText: 'Select an Invoice to calculate the charges'
  },
  invoices: {
    add: {
      htmlTitle: 'Add Invoice | Drip Portal',
      header: 'Add new invoice',
      sortButton: {
        title: 'Sort By: ',
        any: 'Any',
        a2z: 'A to Z',
        z2a: 'Z to A',
        ascending: 'Ascending name',
        descending: 'Descending name'
      },
      title: 'Add Invoice',
      submitDialog: {
        title: 'Please confirm the details below and click Submit to proceed.',
        subtitle:
          'You will not be able to modify your submission after this stage.',
        confirm: 'Looks good, Submit',
        cancel: 'Go back to editing',
        content: {
          supplier: 'Selected supplier:',
          bank: 'Selected bank account:',
          invoices: 'Number of invoice added:',
          individualInvoiceLabel: 'Invoice {number} funding value:',
          preshipmentInvoice: 'Pre-shipment invoice(s):',
          yes: 'Yes',
          no: 'No'
        }
      },
      supplierCheckbox: {
        title: 'Select a supplier',
        subtitle: 'Please select a supplier from the following:',
        subtextPrepend:
          "Which supplier is this invoice for? If you don't see your supplier here, please use the",
        subtextAppend: 'widget to add your supplier first.',
        errorMessage: 'Please select any one supplier',
        errorMessageNotFound: 'Please add a new supplier',
        button: {
          next: 'Proceed to bank details',
          cancel: 'Cancel invoice submission'
        },
        exitDialog: {
          title: 'Are you sure you want to cancel?',
          subtitle: 'You will lose the details you have entered.',
          confirm: 'No, continue adding',
          cancel: 'Yes, cancel invoice'
        },
        banner: {
          title: 'Hello!',
          subtitle: 'To submit an invoice, please add a supplier first',
          body: 'You can submit invoices for funding once you add a supplier and your supplier has been approved.',
          cta: 'Add a supplier'
        }
      },
      bankDetails: {
        title: 'Select a bank',
        subtext: 'Please select a supplier bank from the following:',
        seeMore: 'See all accounts',
        errorMessage: 'Please select any one bank account',
        errorMessageNotFound: 'Please add a new bank',
        button: {
          next: 'Proceed to invoice details',
          cancel: 'Cancel invoice submission'
        },
        exitDialog: {
          title: 'Are you sure you want to cancel?',
          subtitle: 'You will lose the details you have entered.',
          confirm: 'No, continue adding',
          cancel: 'Yes, cancel invoice'
        },
        bankCard: {
          accNo: 'Account number',
          swiftCode: 'SWIFT Code/ABA number',
          currency: 'Currency'
        },
        noBankAdded: {
          title: "Unable to add your supplier's bank account?",
          subtext:
            "Proceed to invoice details. You can add your supplier's bank details after submitting your invoice."
        },
        banner: {
          title: 'Bank account needed',
          subtitle:
            "To submit an invoice, please add your supplier's bank account",
          body: "Once you add your supplier's bank account, you can submit an invoice for funding!",
          cta: 'Add bank account'
        },
        unverifiedBank: {
          title:
            'Your bank will be verified through a call. This will not affect invoice processing.',
          subtitle:
            'For compliance purpose, a customer representative will contact you within 24hrs to complete the bank verification call.'
        }
      },
      fileUpload: {
        errorMessage:
          'Please upload at-least 1 commercial invoice, 1 supporting document and funding amount.',
        selectedSupplier: {
          title: 'Selected Supplier',
          button: 'Edit'
        },
        selectedBank: {
          title: 'Selected Bank Account',
          button: 'Edit'
        },
        exitDialog: {
          title: 'Are you sure you want to cancel?',
          subtitle: 'You will lose the details you have entered.',
          confirm: 'No, continue adding',
          cancel: 'Yes, cancel invoice'
        },
        buttons: {
          edit: 'Edit',
          delete: 'Delete',
          submit: 'Submit invoice(s)',
          cancel: 'Cancel invoice submission',
          uploadFile: 'Upload file'
        },
        component: {
          title: 'Invoice {number} details',
          subtext:
            'Please upload your commercial invoice, supporting document(s) and any other additional documents for this invoice. Individual documents should be in PDF format and should not exceed 50 MB in size.',
          uploadedFiles:
            '{ci} Commercial invoice added, {bl} Supporting Document(s) added.',
          uploadedFilesPreshipment:
            '{ci} Commercial invoice added (pre-shipment), {bl} Supporting Document(s) added.',
          uploadedFilesAdditional:
            '{ci} Commercial invoice added, {bl} Supporting Document(s), {add} additional documents added.',
          uploadedFilesAdditionalPreshipment:
            '{ci} Commercial invoice added (pre-shipment), {bl} Supporting Document(s), {add} additional documents added.',
          file: [
            {
              title: 'Commercial invoice',
              subtext: 'Only one commercial invoice is required'
            },
            {
              title: 'Supporting Document(s)',
              subtext:
                'Bill of lading / Proof of shipment / Proof of delivery / Purchase order (at least one is required)'
            },
            {
              title: 'Additional documents',
              subtext: '(Eg. Packing list, Arrival notice/Customs document)'
            }
          ],
          funding: {
            title: 'Funding value',
            subtext: 'Margin will be calculated on the funding value.',
            currencyInput: {
              label: 'Currency',
              placeHolder: 'Click here to select currency'
            },
            amountInput: {
              label: 'Funding value/amount',
              placeHolder: 'Enter amount'
            }
          },
          additionalInstructions: {
            label: 'Additional instructions regarding the invoice',
            placeholder:
              "Provide specific details like Pre-shipment or Post-shipment, funding amount, or any essential instructions for Drip's Operations Team."
          },
          addAnother: {
            title: 'Add another invoice for {supplier}',
            button: 'Add invoice'
          }
        }
      },
      titles: {
        invoiceInfo: 'Invoice Information',
        shippingDetails: 'Shipping Details',
        fundingInfo: 'Funding Information',
        uploadDocs: 'Documents Upload'
      },
      validators: {
        info: 'Please select a seller to save as draft.',
        invoice: 'This invoice already exists.',
        blInfo: 'BL Number already used',
        bankInfo: 'Please Select a Bank to proceed further'
      },
      exhibit: 'Please wait while we generate your Exhibit-A for E-Sign',
      success: {
        success: 'SUCCESS',
        message: 'Your Invoice has been submitted successfully'
      },
      steps: {
        step: 'Step'
      },
      form: {
        buyer: 'Seller',
        currency: 'Currency',
        reference: 'Invoice Number',
        value: 'Net Invoice Value',
        maxAmount: 'Margin Money Expected',
        invoiceDate: 'Invoice Date',
        invoiceDueDate: 'Invoice Due Date',
        autoCalculated: 'Auto Calculated Invoice Due Date',
        depositDate: 'Estimated Date of Deposit',
        userDueDate: 'Estimated Due Date',
        estimatedSubtext:
          'The Due date for you to pay Drip, in case this invoice is financed by us',
        invoiceSubtext:
          'The Due date of the invoice for you to pay the supplier',
        depositSubtext:
          'If we were to approve this invoice today, what would be the estimated date of our bank reflecting these funds in our account',
        autoCalculatedSubtext:
          'This Is the due date that has been calculated As per the payment terms selected by you',
        updateDueDate: 'Update Due Date to this Value',
        dischargeDate: 'Date of Discharge',
        shippingBillDate: 'Shipping Bill Date',
        shippingBillNumber: 'Shipping Bill No.',
        blNo: 'BL Number',
        blDate: 'BL Date',
        container: 'Container Number',
        shippingLine: 'Shipping Line',
        consignee: 'Consignee',
        vesselName: 'Vessel Name',
        clientBankDetailId: 'Disbursement Bank',
        fundingType: 'Funding Type',
        customerNotes: 'Additional Notes, If Any',
        submit: 'Save & Proceed',
        paymentTerms: {
          bl: 'Days from BL Date',
          cad: 'CAD',
          invoiceDate: 'Invoice Due Date'
        },
        invoiceReason: {
          funding: 'Fund New Invoice',
          adjustment: 'Adjust Against Existing'
        },
        adjustedInvoices: 'Invoices To Be Adjusted, If Any'
      },
      helpers: {
        buyer: {
          label: 'Seller',
          placeHolder: 'Select Seller'
        },
        payment: {
          label: 'Payment Terms'
        },
        days: {
          label: 'Days',
          placeHolder: 'Enter Days'
        },
        invoiceNo: {
          label: 'Invoice Number',
          placeHolder:
            'Enter invoice reference number you can use to track in future'
        },
        invoiceDate: {
          label: 'Invoice Date',
          placeHolder: 'Date of invoice'
        },
        invoiceDueDate: {
          label: 'Invoice Due Date',
          placeHolder: 'Enter Invoice Due Date'
        },
        depositDate: {
          label: 'Estimated Date of Deposit',
          placeHolder: 'Date of Estimated Deposit'
        },
        currency: {
          label: 'Currency',
          placeHolder: 'Select Currency'
        },
        grossValue: {
          label: 'Gross Value',
          placeHolder: 'Enter Amount'
        },
        advanceReceived: {
          label: 'Advance Received From Buyer',
          placeHolder: 'Enter Amount'
        },
        netValue: {
          label: 'Net Invoice Value',
          placeHolder: 'Enter Amount'
        },
        maxValue: {
          label: 'Maximum Financeable Amount',
          note: 'Actual amount may be lesser subject to availability of limits and other factors'
        },
        marginAmount: {
          label: 'Margin Money Expected'
        },
        dischargeDate: {
          label: 'Date of Discharge',
          placeHolder: 'Select Discharge Date'
        },
        shippingLine: {
          label: 'Shipping Line',
          placeHolder: 'Enter Shipping Line'
        },
        consignee: {
          label: 'Consignee',
          placeHolder: 'Enter Consignee'
        },
        vesselName: {
          label: 'Vessel Name',
          placeHolder: 'Enter Vessel Name'
        },
        userDueDate: {
          label: 'Estimated Due Date',
          placeHolder: 'Select Due Date'
        },
        containerNo: {
          label: 'Container Number',
          placeHolder: 'Enter Container Number'
        },
        blNo: {
          label: 'BL Number',
          placeHolder: 'Enter BL Number'
        },
        blDate: {
          label: 'BL Date',
          placeHolder: 'Select BL Date'
        },
        fundingType: {
          label: 'Funding Type: New'
        },
        clientBankDetailId: {
          label: 'Disbursement Bank'
        },
        customerNotes: {
          label: 'Additional Notes, If Any'
        },
        adjustedInvoices: {
          label: 'Invoices To Be Adjusted, If Any',
          placeHolder: 'Select Invoices'
        },
        dropFileHere: ' Drop File Here',
        uploadFile: 'Upload file',
        uploadFiles: 'Upload file(s)',
        addFile: 'Add file'
      },
      actions: {
        next: 'Next',
        save: 'Save as Draft',
        back: 'Back'
      },
      progressSteps: [
        {
          step: '1',
          text: 'Invoice Information'
        },
        {
          step: '2',
          text: 'Shipping Details'
        },
        {
          step: '3',
          text: 'Funding Information'
        },
        {
          step: '4',
          text: 'Documents Upload'
        }
      ]
    },
    esign: {
      infoMessage:
        'Exhibit-A is a request for funding the Supplier Invoices being submitted subject to the terms and conditions contained therein.',
      dialog: {
        title: 'Invoice(s) Submitted Successfully',
        subtitle:
          'As per our revised terms & conditions, you can now E-sign the invoices immediately after submitting.',
        second_subtitle:
          'This will speed up the funding process. Once E-signed, your invoices can be funded within 24 hours of receiving your margin payment.',
        button: 'Continue to E-sign'
      },
      title: 'Exhibit-A for the following invoice(s) is ready for E-sign:',
      noDocs: "We couldn't find any invoices that require an E-Signature.",
      noDocsTitle:
        "You don't have any invoices containing documents for E-sign",
      noDocsSubtitle:
        'When you will add new invoice it will automatically reflect here after verifying by Drip team',
      esignNow: 'E-Sign Now',
      toolTip: 'You are not authorized to E-Sign',
      viewAll: 'View All Invoices',
      fields: [
        {
          key: 'reference',
          label: 'Invoice Number'
        },
        {
          key: 'exporter',
          label: 'Seller'
        },
        {
          key: 'value',
          label: 'Net Invoice Value'
        }
      ]
    },
    upload: {
      subtitle: 'Add Invoice Documents',
      addInvoice: 'Do you want to add another Invoice?',
      saveUpload: 'Yes, Save & Upload Another Invoice',
      noSaveProceedEsign: 'No, Save & Proceed with E-Sign',
      noSaveProceed: 'No, Save & Proceed',
      proceed:
        'Do you want to proceed without uploading all documents? You can come back and finish uploading later.',
      uploadLater: 'Yes, upload later',
      continue: 'Continue uploading',
      proceedWithoutUploading:
        'Do you want to proceed without uploading all documents? You can come back and finish uploading later.',
      fileUpload: {
        upload: 'Upload',
        remove: 'Remove File',
        select: 'Click here to select file or drag and drop document here',
        size: '*Max File Size: 50MB'
      },
      continueToEsign: 'Generate Exhibit-A',
      esign: 'E-Sign',
      pleaseEsign: 'Please upload all documents to E-Sign',
      addMoreInvoices: 'Add More Invoices'
    },
    single: {
      printSave: 'Print / Save',
      breadcrumb: {
        page: 'Invoices',
        section: 'New invoice received'
      },
      draftInvoice: {
        alert: {
          title: 'We are currently processing this invoice',
          subtitle:
            'Details for this invoice will be available here once processing is complete.'
        }
      },
      account: {
        accountDetails: 'Account details',
        accountDataUpdates: 'Account Data Updates',
        accountDataSubtitle:
          'Data updates for your account helps us manage risk effectively and also benefits you, allowing us to offer timely services like credit limit increases when needed.',
        plaidTitle: 'Plaid Connections OR Bank Statements',
        plaidSubtitle:
          'Plaid Connections (if broken/not connected) or Bank statements are needed to be updated timely manner.',
        plaidConnectionsTitle: 'Plaid Connections',
        plaidConnectionsSubtitle: 'Last Connected:',
        bankStatementsTitle1: 'Bank Statements ',
        bankStatementsTitle2: '(from {startDate} to {endDate})',
        onlyPdfMessage:
          'Only PDF files allowed and file size should not exceed 50 MB.',
        financialStatementsTitle1: 'Financial Statements ',
        financialStatementsTitle2: '(from {startDate} to {endDate})',
        uploadBankStatements: 'Upload Bank Statements',
        profitAndLossStatements: 'Profit and Loss Statement and Balance Sheet',
        taxReturnsStatements: 'Latest Tax Returns',
        itrStatementTitle: 'Tax Returns',
        completed_chip_flag: 'Update completed',
        pending_chip_flag: 'Update pending',
        accountDataRequired: 'Account Data Update Required!',
        financials: 'Update Financials',
        financialsAndBank: 'Update Financials and Bank Statements',
        financialsAndPlaid: 'Update Financials and Plaid',
        financialsBankItr: 'Update Financials, Bank Statements and ITR',
        financialsPlaidItr: 'Update Financials, Plaid and ITR',
        financialsAndItr: 'Update Financials and ITR',
        bankAndItr: 'Update Bank Statements and ITR',
        plaidAndItr: 'Update Plaid and ITR',
        bank: 'Update Bank Statements',
        itr: 'Update ITR',
        plaid: 'Update Plaid',
        accountDataRequiredSubtitle:
          'Please update the required data by {blockDate} to avoid revoking invoice upload access.',
        addNewAccount: 'Add new account',
        submitFiles: 'Submit files',
        invoiceBlockText:
          'Your invoice flow has been blocked. Please update the data below to submit an invoice.',
        updateNow: 'Update now',
        PageGettingUpdated: 'Your account page is getting updated.',
        stayTuned: 'Stay tuned!',
        summary: {
          title: 'Summary',
          fields: {
            dripLimit: 'Total Drip limit',
            dripBaseLimit: 'Drip base limit',
            overDraftLimit: 'Overdraft limit',
            totalDripBaseLimit: 'Total Drip base limit'
          }
        },
        pricing: {
          title: 'Pricing Details',
          banner: 'The updated terms are applicable as of ',
          fields: {
            interestRate: {
              title: 'Interest rate',
              description:
                'Annual interest rate charged on the principal amount advanced by Drip Capital'
            },
            transactionFee: {
              title: 'Transaction fee rate',
              description: 'A fixed rate charged on the net invoice value'
            },
            overdraftServiceRate: {
              title: 'Overdraft premium transaction fee rate',
              description:
                'This is a flat percentage charged on the overdraft limit utilized'
            },
            tenure: {
              title: 'Tenure',
              description:
                'Regular credit period of the invoice (days until payment is due)'
            },
            overdueRate: {
              title: 'Overdue rate',
              description:
                'This is a annual interest rate charged on overdue payments'
            },
            days: 'Days'
          }
        }
      },
      info: {
        title: 'Invoice Information',
        reference: 'Reference',
        seller: 'Seller',
        buyer: 'Buyer',
        invoiceValue: 'Invoice Value',
        containerNumber: 'Container Number',
        blDate: 'BL Date',
        paymentTerms: 'Payment Terms',
        dueDate: 'Due Date'
      },
      infoV2: {
        invoiceInformation: '1. Invoice Information',
        shippingDetails: '2. Shipping Details',
        fundingInformation: '3. Funding Information'
      },
      disbursements: {
        title: 'Disbursements',
        advance: 'Advance #',
        total: 'Total',
        totalAdvanced: 'Total Advanced'
      },
      payments: {
        title: 'Payments',
        payment: 'Payment #',
        total: 'Total',
        totalPayments: 'Total Payments'
      },
      banking: {
        title: 'Drip Capital Bank details',
        desc: 'Please refer the below section for Drip Bank Instructions to be placed on the invoice',
        fields: {
          bankName: 'Bank Name',
          bankAddress: 'Bank Address',
          aba: 'ABA Routing',
          accName: 'Account Name',
          accNo: 'Account Number',
          swift: 'Swift',
          achAba: 'For ACH (ABA Routing)'
        }
      },
      statement: {
        title: 'Charges Calculations',
        netValue: 'Net Invoice Value',
        setOffAgainst: 'Set Off Against',
        setOffFrom: 'Set Off From',
        refNo: 'Ref No',
        date: 'Date',
        transactionType: 'Transaction Type',
        credit: 'Credit',
        debit: 'Debit',
        outstanding: 'Outstanding Balance',
        expectedChargesAsOn: 'Expected Charges as on',
        viewDetails: 'View Details',
        closeDetails: 'Close Details',
        today: 'Today',
        differendDate: 'Choose a Different Date',
        totalAmount: 'Total Amount',
        remittanceBank: 'Remittance Bank',
        payeeMemo: 'Payee Memo',
        viewCopy: 'View Swift Copy',
        forInvoices: 'For Invoices',
        expectedCharges: {
          title: 'Calculate your charges for specific dates.',
          subtext:
            'You can check the latest fees and interest rates applied to this invoice with choosing different dates',
          buttonText: 'Go to charges calculator'
        }
      },
      outstanding: {
        title: 'Outstanding as on',
        today: 'Today',
        amount: 'Amount Outstanding',
        expectedTotal: 'Expected Total Charges',
        viewDetails: 'View Details',
        expectedSettlement: 'Expected Settlement Amount',
        expectedSettlementHint:
          'Amount Outstanding - Disbursements - Expected Total Charges',
        expectedTaxCalculation: 'Expected Tax Calculation',
        taxCalculation: 'Tax Calculation',
        isr: 'ISR',
        fourPercentOfTotalCharges: '4% of total charges'
      },
      settlement: {
        title: 'Settlement',
        total: 'Total Charges',
        amount: 'Settlement Amount',
        amountHint: 'Payments - Disbursements - Total Charges',
        date: 'Settlement Date',
        bank: 'Settlement Bank',
        viewDetails: 'View Details'
      },
      updates: {
        title: 'Invoice Updates',
        on: 'on'
      },
      documents: {
        title: 'Documents',
        pending: 'Pending Documents',
        uploaded: 'Uploaded Documents',
        date: 'Uploaded on'
      },
      modals: {
        charges: {
          title: 'Total Charges Breakup',
          expected: 'Expected',
          factoringFee: 'Factoring Fee',
          percentOn: '% on',
          invoiceValue: '(Invoice Value)',
          interest: 'Interest',
          pa: '% P.A.',
          on: 'on',
          totalAdvanceFor: '(Total Advance) for',
          invoiceValueFor: '(Invoice Value) for',
          days: 'days',
          regularInterest: 'Regular Interest on',
          totalAdvance: 'Total Advance',
          advance: 'Advance #',
          for: 'for',
          overdueInterest: 'Overdue Interest on Total Advance',
          otherFees: 'Other Fees',
          processingFee: 'Processing Fee',
          docFees: 'Doc Fees',
          adjustments: 'Adjustments',
          totalCharges: 'Total Charges'
        }
      },
      charges: {
        expected: 'Expected Interest',
        interest: 'Interest',
        info: '{rate}% ({compound}) on {value} for {duration} days '
      },
      tabs: {
        submitted: 'Submitted Details',
        details: 'Details',
        documents: 'Documents',
        summary: 'Summary',
        statement: 'Charges'
      },
      downloadInvoice: 'Download Advice'
    },
    index: {
      title: 'Invoices',
      newInvoiceToast: {
        title: 'Submit a new invoice for funding',
        subtext:
          'You can submit new invoices for funding with just a few clicks',
        buttonText: 'Add invoice',
        buttonDisabledText: 'You are not authorized to proceed'
      },
      eSignPendingToast: {
        subtext: 'Exhibit-A(s) pending to be E-signed',
        buttonText: 'View list'
      },
      invoiceProcessingChip: 'New invoice',
      customerNotesPreText: 'Additional comments: ',
      esignInvoices: 'E-Sign Invoices',
      addInvoice: 'Add Invoice',
      pending: 'Pending Advance',
      outstanding: 'Advanced',
      received: 'Pending Settlement',
      settled: 'Settled',
      searchResults: 'Search results for',
      searchInvoice: 'Search for an invoice...',
      noInvoices:
        'No invoices found for the current filters. Please change filters or try different search terms.',
      view: 'View →',
      edit: 'Edit →',
      filter: 'Filter by',
      list: 'Invoice List',
      outstandingFields: [
        {
          key: 'reference',
          label: 'Reference',
          sortable: true
        },
        {
          key: 'importer',
          label: 'Importer',
          sortable: true
        },
        {
          key: 'advanced_date',
          label: 'Advanced Date',
          sortable: true
        },
        {
          key: 'value',
          label: 'Invoice Value',
          sortable: true
        },
        {
          key: 'total_advanced',
          label: 'Total Advanced',
          sortable: true
        },
        {
          key: 'payment_total',
          label: 'Payments Received',
          sortable: true
        },
        {
          key: 'outstanding',
          label: 'Outstanding From Buyer',
          sortable: true
        },
        {
          key: 'advice_exporter_fees',
          label: 'Expected Charges',
          sortable: true
        },
        {
          key: 'repayment',
          label: 'Due Date',
          sortable: true
        },
        {
          key: 'user_stage_human',
          label: 'Status'
        },
        {
          key: 'actions',
          label: 'Actions'
        }
      ],
      settledFields: [
        {
          key: 'reference',
          label: 'Reference',
          sortable: true
        },
        {
          key: 'importer',
          label: 'Importer',
          sortable: true
        },
        {
          key: 'value',
          label: 'Invoice Value',
          sortable: true
        },
        {
          key: 'advanced_date',
          label: 'Advanced Date',
          sortable: true
        },
        {
          key: 'total_advanced',
          label: 'Total Advanced',
          sortable: true
        },
        {
          key: 'received_amount',
          label: 'Received Amount',
          sortable: true
        },
        {
          key: 'exporter_fees',
          label: 'Charges',
          sortable: true
        },
        {
          key: 'settlement',
          label: 'Settlement Amt',
          sortable: true
        },
        {
          key: 'settlement_date',
          label: 'Settlement Date',
          sortable: true
        },
        {
          key: 'actions',
          label: 'Actions'
        }
      ],
      receivedFields: [
        {
          key: 'reference',
          label: 'Reference',
          sortable: true
        },
        {
          key: 'importer',
          label: 'Importer',
          sortable: true
        },
        {
          key: 'advanced_date',
          label: 'Advanced Date',
          sortable: true
        },
        {
          key: 'value',
          label: 'Invoice Value',
          sortable: true
        },
        {
          key: 'total_advanced',
          label: 'Total Advanced',
          sortable: true
        },
        {
          key: 'received_amount',
          label: 'Received Amount',
          sortable: true
        },
        {
          key: 'exporter_fees',
          label: 'Expected Charges',
          sortable: true
        },
        {
          key: 'settlement',
          label: 'Expected Settlement Amt',
          sortable: true
        },
        {
          key: 'actions',
          label: 'Actions'
        }
      ],
      pendingFields: [
        {
          key: 'reference',
          label: 'Reference',
          sortable: true
        },
        {
          key: 'importer',
          label: 'Importer',
          sortable: true
        },
        {
          key: 'value',
          label: 'Invoice Value',
          sortable: true
        },
        {
          key: 'user_stage_human',
          label: 'Status'
        },
        {
          key: 'actions',
          label: 'Actions'
        }
      ],
      require: {
        text: 'Showing invoices that require {filter}',
        information: 'critical information',
        documents: 'critical documents',
        esign: 'e-signature'
      },
      exportData: {
        title: 'Download Invoices',
        exportInvoicesData: 'Export Invoices Data',
        export: 'Export',
        required: 'This field is required',
        labels: {
          from: 'From',
          to: 'To'
        }
      },
      downloadInvoice: 'Download Advice',
      editDraft: 'Edit Draft',
      viewInvoice: 'View Invoice',
      only: 'Only'
    }
  },
  alerts: {
    viewInvoices: 'View Invoices',
    dashboard: {
      esignPending:
        'Exhibit-A for 1 invoice need an E-signature. | Exhibit-A for {count} invoices need an E-signature',
      esignPendingCta: 'E-Sign Documents'
    },
    invoiceList: {
      esignPending: {
        title: 'E-Sign Required!',
        message:
          'Exhibit-A for 1 invoice need an E-signature. | Exhibit-A for {count} invoices need an E-signature',
        cta: 'E-Sign Now'
      }
    },
    invoice: {
      esignPending: 'Exhibit-A for this invoice needs an E-signature.',
      esignPendingCta: 'E-Sign Documents',
      esignRequired: 'E-Sign Required!'
    }
  },
  bankDetails: {
    seoTitle: 'Bank Details',
    title: 'Drip Capital Inc. Bank Details',
    description:
      'Drip Capital is a Trade Finance company providing collateral-free post-shipment finance to Indian exporters with instant approvals and minimal documentation.',
    requestError: 'Unauthorized Request',
    keys: {
      bankName: 'Bank Name',
      bankAddress: 'Bank Address',
      benbankName: 'Beneficiary Bank Name',
      benbankAddress: 'Beneficiary Bank Address',
      benAccCredit: 'Beneficiary Name (For Credit To)',
      accName: 'Account Name (For Credit To)',
      achAccName: 'Account Name (For Credit To)',
      accNo: 'Account No.',
      achAccNo: 'Account No.',
      achBankRoutingNumber: 'Bank Routing Number',
      accAddress: 'Beneficiary Address',
      benAccName: 'Beneficiary Account Name',
      benSwift: 'Beneficiary SWIFT Code',
      bNo: 'Beneficiary Account No.',
      aba: 'ABA Routing & Transit No.',
      bankRoutingNumber: 'Bank Routing Number',
      swift: 'SWIFT Code',
      swiftIf: 'Swift Code (If Needed)',
      iban: 'IBAN',
      bankSortCode: 'Bank Sort Code',
      clabe: 'CLABE',
      beneficiary: {
        bankName: 'Beneficiary Bank Name',
        bankAddress: 'Beneficiary Bank Address',
        swift: 'Beneficiary SWIFT Code',
        accName: 'Beneficiary Name (For Credit To)',
        accNo: 'Beneficiary Account No.'
      },
      correspondent: {
        bankName: 'Correspondent Bank Name',
        bankAddress: 'Correspondent Bank Address',
        swift: 'Correspondent Bank SWIFT'
      }
    },
    usd: {
      title: 'USD ($)',
      desc1:
        'Please remit all United States Dollar (USD) payments electronically to:'
    },
    euro: {
      title: 'EUR (€)',
      desc1:
        'Please remit all Euro (EUR) payments electronically via SEPA or Wire to:'
    },
    pound: {
      title: 'GBP (£)',
      desc1:
        'Please remit all British Pound Sterling (GBP) payments electronically via Faster Payments (if payment less than GBP 250,000) or CHAPS (if more than GBP 250,000) to:',
      desc2: 'For CHAPS payment'
    },
    cad: {
      title: 'CAD (C$)',
      desc1:
        'Please remit all Canadian Dollar (CAD) payments electronically to:'
    }
  },
  bankDetailsJpmGoTrade: {
    mainTitle: 'Drip Capital Inc. Bank Details',
    seoTitle: 'Bank Details',
    title1: 'Wire Transfers',
    title2: 'ACH Payments',
    description:
      'Drip Capital is a Trade Finance company providing collateral-free post-shipment finance to Indian exporters with instant approvals and minimal documentation.',
    desc1: 'Please remit all payments electronically to:'
  },
  bankDetailsJpm: {
    title: 'JP MORGAN',
    desc1: 'Please remit all payments electronically to:'
  },
  region: {
    business: 'India'
  },
  custom: {
    'Invoice Due Date': {
      is: 'Invoice Due Date Is Not According To Payment Terms'
    }
  },
  plaid: {
    powered: 'Powered By',
    bankDetails:
      'Please verify your bank account below. This helps us with final approval of your application.',
    footnotes:
      "Drip Capital uses state-of-the-art security measures and encryption to keep your information safe, and will never have access to your banking credentials. This connection is read-only, which means it can't be used to move money into or out of bank accounts.",
    loading: 'Loading...',
    verify: 'Verify My Bank Account',
    update: 'Update My Bank Account',
    errorMessage:
      'Something went wrong. Please contact your respective Account Manager.',
    alert: {
      title:
        'Action needed: You may be missing out on better limits and pricing',
      body: 'Authorize Drip to access your primary bank account(s) to help us offer you the best limits and pricing. Authorization is easy and only takes 2 minutes.',
      button: 'Authorize new account'
    }
  },
  invoiceFilter: {
    tooltip: {
      pending: 'Invoice awaiting submission',
      processing: 'Invoice in underwriting',
      approved: 'Invoice underwriting complete and awaiting margin deposit',
      deposited: 'Margin deposit received',
      advanced: 'Supplier payment made',
      settled: 'Invoice repaid'
    }
  },
  clickWrap: {
    heading1: 'Invoice Documents dated',
    heading2:
      'Please read the document(s) carefully and scroll to the bottom to accept and E-sign.',
    consentTitle:
      'Please provide your consent by clicking on the check box. You can only E-sign after clicking on the checkbox.',
    consentText:
      'I have read and understood the document and agree to the information contained therein. By checking the box, typing your name and pressing "Submit" you confirm that you have read and understood this document and you legally bind the borrower in terms hereof. ',
    inputLabel: 'Signature',
    inputButton: 'Complete E-sign',
    scrollToBottom: 'Scroll to the bottom',
    validations: {
      required: 'Your name is required',
      alpha: 'Please remove any special characters (.,/,<,>,*, %)'
    },
    esignPostLoading: 'Processing your E-sign',
    esignDocumentIdMissing: 'Document could not be fetched!',
    esignFailedAlert: {
      title: 'E-sign Failed',
      text: 'Failed to sign document.'
    },
    esignSuccessAlert: {
      title: 'E-sign Successful',
      text: 'We will further review your invoice(s) and update you on the next steps.'
    }
  },
  supplier: {
    list: {
      page: 'List of suppliers',
      header: 'List of suppliers',
      title: 'List of suppliers',
      supplierStep: {
        title: 'No suppliers yet!',
        subtext: 'Add a new supplier in 2 simple steps!',
        step1: 'Fill up basic details about your supplier',
        step2: "Provide your supplier's bank details",
        step3: 'Your supplier has been created!',
        button: 'Add a new supplier'
      },
      searchSupplier: {
        label: 'Search for a supplier',
        placeholder: 'For eg. ABC Company',
        button: 'Search'
      },
      tableSupplier: {
        addBank: 'Add bank account',
        editSupplier: 'View/Edit Supplier',
        info: {
          processing:
            'The supplier is still under review. You can submit invoices for this supplier',
          'on hold':
            'Please contact your account manager for more details. You can submit invoices for this supplier',
          active:
            'The supplier is approved! You can submit invoices for this supplier',
          rejected:
            'Please contact your account manager for more details. Invoices will not be financed for this supplier'
        }
      },
      addMoreSupplier: {
        title: 'Add more suppliers',
        subtitle:
          'Add a new supplier in 2 simple steps and get your invoice funded.',
        button: 'Add new supplier'
      },
      addMoreBank: {
        title: 'Add a bank account',
        subtitle: 'You can add multiple bank accounts for a single supplier.',
        button: 'Add bank account'
      }
    },
    addSupplier: {
      header: 'Supplier details',
      addTitle: 'Add a new Supplier',
      updateTitle: 'Edit Supplier',
      form: {
        title: "Enter your supplier's company details",
        companyName: {
          label: 'Company name',
          placeholder: 'e.g. ABC Company Pvt. Ltd.'
        },
        companyCountry: {
          label: 'Company country',
          placeholder: 'e.g. United States of America'
        },
        streetAddress: {
          label: 'Street address',
          placeholder: 'e.g. 12 street, Abc road, XYZ city, 12345'
        },
        contactTitle: "Enter your supplier's contact details",
        contactSubtext:
          'Please be assured that we will not reach out to your supplier for any reason.',
        contactName: {
          label: 'Contact name',
          placeholder: 'e.g. John Doe'
        },
        contactEmail: {
          label: 'Contact email',
          placeholder: 'e.g. John@company.com'
        },
        contactPhone: {
          label: 'Contact phone',
          placeholder: 'e.g.+1 234 567 8901'
        },
        subtextTitle: 'Documents required for supplier addition',
        subtextTitle2:
          'We require a past commercial invoice and the corresponding payment proof.',
        subtextSubtitle:
          'Note: Individual documents should be in PDF format and should not exceed 50 MB in size.',
        subtextNote:
          'Since your supplier is outside United States, this step is optional for you.',
        uploads: {
          downloadBtn: 'Download',
          pci_docs: {
            title: 'Past commercial invoice',
            subtext:
              'A commercial invoice with both buyer and supplier names. It should not be a pro-forma invoice.',
            errorMessage: 'Commercial invoice is required.'
          },
          pop_docs: {
            title: 'Corresponding payment proof',
            subtext:
              'A document that can confirm invoice payment to the above uploaded invoice.',
            errorMessage: 'Proof of payment is required.'
          }
        },
        buttonUpdate: 'Update supplier details',
        buttonAdd: 'Proceed to bank details'
      },
      successAddSupplier: 'Supplier created successfully.',
      successUpdateSupplier: 'Supplier details updated successfully'
    },
    addBank: {
      header: 'Add bank account',
      headerUpdate: 'Edit bank account',
      title: "Enter your supplier's bank details",
      form: {
        title: "'s bank account details",
        subtext: 'This is where Drip will send payments to your supplier',
        beneficiary_name: {
          label: 'Beneficiary name',
          placeholder: 'e.g. ABC Supplier'
        },
        bank_name: {
          label: 'Beneficiary bank name',
          placeholder: 'e.g. ABC Bank'
        },
        bank_city: {
          label: 'Beneficiary bank city',
          placeholder: 'e.g. California'
        },
        beneficiary_account: {
          label: 'Beneficiary account number/IBAN',
          placeholder: 'e.g. 123456789'
        },
        swift_code: {
          label: 'SWIFT code / ABA routing number',
          placeholder: 'e.g. ABCDEFGHKLM / 123456789',
          errorMessage: 'Minimum 8 and maximum 11 characters.'
        },
        aba_routing: {
          label: 'ABA routing number (for suppliers in US only)',
          placeholder: 'e.g. 123456789'
        },
        currency: {
          label: 'Currency',
          placeholder: 'e.g. USD'
        },
        int_bank_name: {
          label: 'Intermediary bank name (optional)',
          placeholder: 'e.g. ABC Bank'
        },
        int_bank_swift_code: {
          label: 'Intermediary bank SWIFT code (optional)',
          placeholder: 'e.g. ABCDEFGHKLM'
        },
        buttonUpdate: 'Update bank details',
        buttonAddBank: 'Complete bank addition'
      },
      successAddBank: 'Supplier bank added successfully.',
      successUpdateBank: 'Supplier bank details updated successfully'
    },
    view: {
      subtext:
        "You can edit your supplier and supplier bank details while it's under verification. We will notify you once they are verified.",
      contact: {
        title: 'Supplier details'
      },
      company: {
        title: 'Supplier details',
        companyTitle: 'Supplier company details',
        name: 'Company name',
        country: 'Company country',
        address: 'Street address',
        contactTitle: 'Contact details',
        contactName: 'Contact name',
        contactEmail: 'Contact email',
        contactNumber: 'Contact number',
        documentsTitle: 'Proof of relationship documents',
        pci: {
          title: 'Past commercial invoice',
          subtext:
            'A commercial invoice with both buyer and supplier names. It should not be a pro-forma invoice.'
        },
        pop: {
          title: 'Past proof of payment',
          subtext:
            'A document that can confirm invoice payment to the supplier.'
        }
      },
      bank: {
        title: 'Supplier bank details',
        accountNumber: 'Account number',
        abaRouting: 'ABA number',
        swift: 'SWIFT code/ABA number',
        currency: 'Currency'
      }
    },
    sideWidget: {
      active: {
        title: 'Submit an invoice for ',
        subtext:
          'You can now submit new invoices for funding with just a few clicks.'
      },
      processing: {
        title: 'Submit an invoice for ',
        subtext:
          'You can now submit new invoices for funding with just a few clicks.'
      },
      pending: {
        title: 'Supplier on hold',
        subtext: 'Please contact your account manager for more details.'
      },
      rejected: {
        title: 'Supplier rejected',
        subtext: 'Please contact your account manager for more details.'
      },
      button: 'Add a new invoice'
    }
  },
  accountSummary: {
    back: 'Back',
    heading: 'Account Reports',
    title: 'Your Account Details',
    accountSummaryFields: [
      {
        key: 'accountName',
        label: 'Account name',
        class: 'reference-cell pl-1 pl-md-3',
        sortable: false
      },
      {
        key: 'totalFacility',
        label: 'Total Facility Limit',
        class: 'reference-cell pl-1 pl-md-3',
        sortable: false
      },
      {
        key: 'usedFacility',
        label: 'Used Facility Limit (as on current date)',
        class: 'reference-cell pl-1 pl-md-3',
        sortable: false
      }
    ],
    note: {
      title: 'Download account reports:',
      list_item_1:
        'The account reports will only include invoices which are advanced. ',
      list_item_2:
        "Fees will be calculated as on current (today's) date for advanced and overdue invoices",
      list_item_3: 'Payments are applied as of the date we receive them.'
    },
    supplier: {
      title: 'Select a supplier:',
      label: 'Suppliers'
    },
    date_range: {
      title: 'Select a date range:',
      option_1: 'Last 30 days',
      option_2: 'Last 3 months',
      option_3: 'Last financial year'
    },
    date: {
      or: 'Or',
      from: 'From',
      to: 'To',
      validation: "The 'From Date' must be earlier than the 'To Date'.",
      download_button: 'Download summary'
    }
  },
  achBankAccount: {
    heading: 'ACH Accounts',
    addNewAccountText: 'Add a new ACH Bank Account',
    setAsDefault: 'Set as Default',
    edit: 'Edit',
    card: {
      title: 'Add an ACH Bank Account for Smooth Payment Processing',
      subTitle:
        'Adding an ACH bank account ensures secure and seamless transactions, benefiting both you and Drip Capital as your lending partner.',
      button: 'Add ACH Bank(s)'
    },
    status: {
      default: 'Default',
      verificationPending: 'Verification Pending',
      verified: 'Verified'
    },
    table: {
      title: 'ACH Bank Accounts'
    },
    formPage: {
      title: 'Add Bank Details',
      breadcrumbText: 'Add ACH Account',
      sideBar: {
        addBankDetails: 'Add Bank Details',
        accountHolderDetails: 'Account Holder Details',
        authorization: 'Authorization'
      },
      bankAccountDetails: {
        title: 'Bank Account Details',
        subtitle:
          'Please enter your bank account details below. USD-denominated accounts only.',
        bankName: 'Bank Name',
        bankNamePlaceholder: 'Enter Bank Name',
        bankFedNumber: 'Bank Fed ABA/Routing Number',
        bankFedNumberPlaceholder: 'Enter Fed ABA Number',
        accountNumber: 'Account Number',
        accountNumberPlaceholder: 'Enter Account Number',
        bankCurrency: 'Bank Currency',
        usd: 'USD',
        accountType: 'Account Type',
        accountTypePlaceholder: 'Select Account Type',
        bankAddress: 'Bank Address',
        bankStreetAddress: 'Street Address',
        bankStreetAddressPlaceholder: 'Enter street address',
        bankCity: 'City',
        bankCityPlaceholder: 'Enter city',
        bankState: 'State/Region',
        bankStatePlaceholder: 'Select state/region',
        bankCountry: 'Country',
        bankCountryPlaceholder: 'Select country'
      },
      bankAccountHolder: {
        title: 'Bank Account Holder Details',
        subtitle:
          'Please enter your bank account details below. USD-denominated accounts only.',
        accountHolder:
          'Account Holder Company Name (as shown in your bank statements)',
        accountHolderPlaceholder: 'Enter Account Holder Company Name',
        accountHolderTitle: 'Account holder address',
        accountStreetAddress: 'Street Address',
        accountStreetAddressPlaceholder: 'Enter street address',
        accountCity: 'City',
        accountCityPlaceholder: 'Enter city',
        accountState: 'State/Region',
        accountStatePlaceholder: 'Select state/region',
        accountCountry: 'Country',
        accountCountryPlaceholder: 'Select country'
      },
      authorization: {
        title: 'Please confirm your account details and provide consent',
        subtitle:
          'Please confirm your account details and provide your authorization to add this account for AutoPay.',
        checkBoxText: 'I agree to authorize Drip Capital for ACH Debit.',
        termsAndConditions:
          'By clicking on the "I agree" button, I hereby authorize Drip Capital Inc. to take appropriate steps to verify the bank account details provided by me. In accordance with the Master Revolving Supply Chain Financing Promissory Note, I also authorize Drip Capital Inc. to periodically execute recurring ACH debits in relation to the above bank account disclosed by me, as and when required. I undertake not to revoke this consent or to dispute any ACH debit transactions with the bank.'
      },
      nextButton: 'Next Step',
      cancelAccount: 'Cancel Account Addition',
      submit: 'Submit',
      completeButton: 'Complete Bank Addition'
    }
  },
  selectAchAccount: {
    achAccount: 'ACH Accounts',
    addAchAccount: 'Add ACH Bank Account',
    infoText:
      'Please add bank account(s) that are active and have sufficient funds.',
    selectBankTitle: 'Select from existing bank account(s):',
    selectBanksubtitle: 'You can select more than one bank account.',
    seeAllAccounts: 'See all accounts',
    addNewBankTitle: 'Add a new bank account for ACH',
    addNewBankButtonText: 'Add New Bank',
    submitBankDetails: 'Add Bank Details'
  },
  messages: {
    required: (fieldName) => `${fieldName} is required.`,
    alpha_num: 'This field may only contain alpha-numeric characters.',
    remove_specials: 'Please remove any special characters (.,/,<,>,*, %)',
    remove_number: 'Please remove any numbers.',
    remove_specials_spaces:
      'Please remove any special characters (.,/,<,>,*, %) or spaces',
    numbers_only: 'Only numbers allowed.',
    confirmed: 'The confirmation should match the password.',
    email: 'This field is not valid',
    min: (fieldName, length) =>
      `This field must be at least ${length} characters`,
    max: (fieldName, length) => `Maximum number of characters to be ${length}.`,
    digits: (fieldName, length) =>
      `The ${fieldName} should be ${length} digits only.`,
    numeric: 'This field may only contain numeric characters'
  },
  error: {
    unableToProcess: 'Unable to process your request',
    unauthorizedToolTip: 'You are not authorized to proceed',
    failedEsignDoc: 'Failed to generate document to esign!'
  }
}
